import JobArchitecture from '@/views/JobArchitecture.vue';
import JobArchitectureFamily from '@/views/JobArchitectureFamily.vue';
import JobArchitectureCompare from '@/views/JobArchitectureCompare.vue';
import { jobProfileMiddleware } from '@/helpers/routeMiddleware';

export const jobArchitecture = (authDataStore) => ([
  {
    path: '/job-architecture',
    name: 'job-architecture',
    component: JobArchitecture,
    beforeEnter: jobProfileMiddleware(authDataStore),
    meta: { title: 'Job Architecture' },
  },
  {
    path: '/job-architecture/family/:familyUlid',
    name: 'job-architecture-family',
    component: JobArchitectureFamily,
    beforeEnter: jobProfileMiddleware(authDataStore),
    meta: { title: 'Job family profiles' },
  },
  {
    path: '/job-architecture/compare',
    name: 'job-architecture-compare',
    component: JobArchitectureCompare,
    beforeEnter: jobProfileMiddleware(authDataStore),
    meta: { title: 'Compare job profiles' },
  },
]);
